import type { Theme } from '@mui/material';
import { Box, Typography } from '@mui/material';
import Color from 'color';
import { useCowbellTranslations } from '../../../../../../i18n/translations';

interface IGroupCoverageHeader {
  title: string;
}
const GroupCoverageHeader = ({ title }: IGroupCoverageHeader) => {
  const { t } = useCowbellTranslations('coverage');
  const styleObject = {
    color: (theme: Theme) => theme.palette.primary.contrastText,
    backgroundColor: (theme: Theme) =>
      Color(theme.palette.background.default)
        .lighten(theme.palette.mode === 'dark' ? 0.25 : 0.02)
        .toString(),
    display: 'grid',
    alignItems: 'center',
    justifyItems: 'end',
    '@container (max-width: 840px)': {
      justifyItems: 'center',
    },
  };
  const titleContainerStyleObject = {
    justifyItems: 'start',
    '@container (max-width: 840px)': {
      justifyItems: 'start',
    },
  };
  const textStyleObject = {
    fontWeight: 'bold',
    '@container (max-width: 840px)': {
      fontSize: '1rem',
      textAlign: 'center',
    },
  };
  const titleTextStyleObject = {
    textAlign: 'left',
    '@container (max-width: 840px)': {
      fontSize: '1rem',
      textAlign: 'left',
    },
  };
  return (
    <>
      <Box sx={{ ...styleObject, ...titleContainerStyleObject }}>
        <Typography
          variant="subtitle2"
          sx={{ ...textStyleObject, ...titleTextStyleObject }}
        >
          {title}
        </Typography>
      </Box>
      <Box sx={styleObject}>
        <Typography variant="subtitle2" sx={textStyleObject}>
          {t('limit')}
        </Typography>
      </Box>
      <Box sx={styleObject}>
        <Typography variant="subtitle2" sx={textStyleObject}>
          {t('retention')}
        </Typography>
      </Box>
      <Box sx={{ ...styleObject, justifyItems: 'center' }}>
        <Typography variant="subtitle2" sx={textStyleObject}>
          {t('waitingPeriod')}
        </Typography>
      </Box>
      <Box sx={{ ...styleObject, justifyItems: 'center' }}>
        <Typography variant="subtitle2" sx={textStyleObject}>
          {t('retroActiveDate')}
        </Typography>
      </Box>
    </>
  );
};

export default GroupCoverageHeader;
